module.exports = "/_next/static/images/spouwmuurisolatie-13fe65c8a204d946ef11878011231044.jpg";